import Axios from "axios";
import config from "../app.config";

export var faqBbsService;
export default faqBbsService = {
    fetchFaqBbsList,
    getFaqBbs,
    createFaqBbs,
    updateFaqBbs,
    deleteFaqBbs,
    createFaqBbsAttachment,
    deleteFaqBbsAttachment,
    downloadFaqBbsAttachment,
    fetchFaqBbsSubPost,
    fetchFaqBbsCommentList,
    getFaqBbsComment,
    createFaqBbsComment,
    updateFaqBbsComment,
    deleteFaqBbsComment,
    createFaqBbsCommentAttachment,
    deleteFaqBbsCommentAttachment,
    fetchFaqBbsCategoryList,
    fetchFaqBbsServerList,
    fetchFaqBbsCompanyList,
    copyBbsToCompany,
    countUnreadFaqBbs,
    fetchChargeAdmins,
    deleteFaqBbsNewIcon,
}

async function countUnreadFaqBbs() {
    return await Axios.get(`${config.LOCAL_API_URL}/v1/faq_bbs`, {params: {is_new: true}})
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function fetchFaqBbsList(queryData) {
    return await Axios.get(`${config.LOCAL_API_URL}/v1/faq_bbs`, {params: queryData})
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function fetchChargeAdmins() {
    return await Axios.get(`${config.LOCAL_API_URL}/v1/admins/getChargeAdmin`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
          }).catch(error =>{
              return Promise.reject(error.response);
          })
}

async function getFaqBbs(id) {
    return await Axios.get(`${config.LOCAL_API_URL}/v1/faq_bbs/${id}`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function createFaqBbs(data) {
    return await Axios.post(`${config.LOCAL_API_URL}/v1/faq_bbs`, data)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function updateFaqBbs(id, data) {
    return await Axios.put(`${config.LOCAL_API_URL}/v1/faq_bbs/${id}`, data)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function deleteFaqBbsNewIcon(bbs_id) {
    return await Axios.post(`${config.LOCAL_API_URL}/v1/faq_bbs/del_news_ico`, {bbs_id: bbs_id})
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function deleteFaqBbs(id) {
    return await Axios.delete(`${config.LOCAL_API_URL}/v1/faq_bbs/${id}`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

// TODO: maybe multiple-part data
async function createFaqBbsAttachment(bbsId, data) {
    return await Axios.post(`${config.LOCAL_API_URL}/v1/faq_bbs/bbs_attachment/${bbsId}`, data)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function deleteFaqBbsAttachment(bbsId) {
    return await Axios.delete(`${config.LOCAL_API_URL}/v1/faq_bbs/bbs_attachment/${bbsId}`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function downloadFaqBbsAttachment(attachmentId) {
    return Axios.get(`${config.LOCAL_API_URL}/v1/faq_bbs/bbs_attachment/${attachmentId}`)
}

async function fetchFaqBbsSubPost(data) {
    return await Axios.get(`${config.LOCAL_API_URL}/v1/faq_bbs/list/${data.id}`, { params: data})
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function fetchFaqBbsCommentList(bbsId) {
    return await Axios.get(`${config.LOCAL_API_URL}/v1/faq_bbs/comment_list/${bbsId}?limit=100`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function getFaqBbsComment(commentId) {
    return await Axios.get(`${config.LOCAL_API_URL}/v1/faq_bbs/comment/${commentId}`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function createFaqBbsComment(data) {
    return await Axios.post(`${config.LOCAL_API_URL}/v1/faq_bbs/comment`, data)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function updateFaqBbsComment(commentId,data) {
    return await Axios.put(`${config.LOCAL_API_URL}/v1/faq_bbs/comment/${commentId}`, data)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function deleteFaqBbsComment(commentId) {
    return await Axios.delete(`${config.LOCAL_API_URL}/v1/faq_bbs/comment/${commentId}`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

//TODO: maybe multiple-part-data
async function createFaqBbsCommentAttachment(commentId, data) {
    return await Axios.post(`${config.LOCAL_API_URL}/v1/faq_bbs/comment_attachment/${commentId}`, data)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function deleteFaqBbsCommentAttachment(commentId, data) {
    return await Axios.delete(`${config.LOCAL_API_URL}/v1/faq_bbs/comment_attachment/${commentId}`, { params: data})
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function fetchFaqBbsCategoryList() {
    return await Axios.get(`${config.LOCAL_API_URL}/v1/faq_bbs/category`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function fetchFaqBbsServerList() {
    return await Axios.get(`${config.LOCAL_API_URL}/v1/faq_bbs/server_list`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function fetchFaqBbsCompanyList() {
    return await Axios.post(`${config.LOCAL_API_URL}/v1/faq_bbs/companiesList`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function copyBbsToCompany(bbsId) {
    return await Axios.post(`${config.LOCAL_API_URL}/v1/faq_bbs/copy_bbs_to_company/${bbsId}`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}




